export default "__VITE_ASSET__B6O_euHP__"